export const OpenIcon = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0)">
            <path
                d="M5.62471 7.21881L9.99971 10.7188L14.3747 7.21881C14.4773 7.13673 14.595 7.07566 14.7212 7.03908C14.8473 7.0025 14.9795 6.99113 15.11 7.00562C15.2406 7.0201 15.367 7.06016 15.4821 7.12351C15.5972 7.18685 15.6986 7.27225 15.7807 7.37481C15.8628 7.47737 15.9239 7.59509 15.9604 7.72126C15.997 7.84742 16.0084 7.97956 15.9939 8.11012C15.9794 8.24068 15.9394 8.3671 15.876 8.48218C15.8127 8.59726 15.7273 8.69873 15.6247 8.78081L10.6247 12.7808C10.4473 12.9228 10.2269 13.0002 9.99971 13.0002C9.7725 13.0002 9.55207 12.9228 9.37471 12.7808L4.37471 8.78081C4.16757 8.61505 4.03477 8.37379 4.00552 8.11012C3.97626 7.84644 4.05295 7.58194 4.21871 7.37481C4.30078 7.27224 4.40226 7.18685 4.51733 7.12351C4.63241 7.06016 4.75884 7.0201 4.8894 7.00562C5.15307 6.97636 5.41757 7.05305 5.62471 7.21881Z"
                fill="#1B2D37"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <path
                    d="M20 0L0 -1.74846e-06L-1.74846e-06 20L20 20L20 0Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
